/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elegant_Misty_Fish_GazeInputs */

const fr_elegant_misty_fish_gaze = /** @type {(inputs: Elegant_Misty_Fish_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/**

* @param {Elegant_Misty_Fish_GazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const elegant_misty_fish_gaze = /** @type {((inputs?: Elegant_Misty_Fish_GazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elegant_Misty_Fish_GazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_elegant_misty_fish_gaze(inputs)
});